var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-sidebar"},[_c('b-nav',{attrs:{"vertical":""}},_vm._l((_vm.items),function(item){return _c('NavItem',{key:item.name,attrs:{"title":item.title,"icons":item.icons,"to":item.to,"isActive":_vm.active === item.to.name,"disabled":item.disabled}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }